import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import Accordion from '@Components/Accordion';
import { TextInput } from '@els/els-react--text-input';
import InputToggler from './InputToggler';
import ViewMoreToggler from './ViewMoreToggler';
import EditToggler from './EditToggler';

export default function BarChartFilterControls(props) {
  const { filter, onInputChange } = props;
  const userInputOpen = filter.get('userInputOpen');
  const userInputValue = filter.get('userInputValue');
  const userInputLabel = filter.get('userInputLabel');
  const numeric = filter.get('numeric');

  return (
    <section className="bar-chart-filter-controls">
      <div className="bar-chart-filter-controls-togglers-wrapper">
        <InputToggler {...props} />
        <EditToggler {...props} />
      </div>

      <Accordion
        className="bar-chart-filter-controls-input-wrapper"
        open={userInputOpen}
        content={
          <TextInput
            data-e2e="filter-control"
            id="filter-value-input"
            label={userInputLabel || 'Filter by value'}
            shouldHideLabel={!userInputLabel}
            className="bar-chart-filter-controls-input u-els-margin-top-1o2"
            placeholder={numeric ? 'Enter any number or range' : 'Enter any text'}
            onChange={(e) => onInputChange(e.target?.value)}
            value={userInputValue}
          />
        }
      />

      <ViewMoreToggler className="u-els-margin-top" {...props} />
    </section>
  );
}

BarChartFilterControls.propTypes = {
  filter: PropTypes.instanceOf(Map).isRequired,
  disableViewMore: PropTypes.bool.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onClickViewMore: PropTypes.func.isRequired,
  onClickUserInput: PropTypes.func.isRequired,
  canRenderViewMore: PropTypes.bool.isRequired,
  disableUserInputToggler: PropTypes.bool.isRequired,
};
